module.exports = __webpack_public_path__ + "img/icon-wa.662564c9.svg";